import { useWindowDimensions } from 'react-native';
import { useContext } from 'react';
import { ContentWidthContext } from 'src/presentation/components/layout/ContentWidthContext';

/**
 * Width of the area a component actually gets, and the value to lay out against.
 *
 * Two things this fixes at once. Most callers used to read `Dimensions.get('window')` at module
 * scope, which freezes the value at load time — harmless on a phone that cannot resize, wrong on
 * web and wrong after a rotation. And on a wide screen the app renders in a centred column, so
 * the window width is not the width available: an overlay sized to a 1440px window inside a
 * 500px column is off by nearly a metre of pixels.
 *
 * Use this for anything laid out inside the app. Use `useWindowDimensions` only for something
 * that genuinely covers the whole screen.
 */
export function useContentWidth(): number {
	const columnWidth = useContext(ContentWidthContext);
	const { width } = useWindowDimensions();

	return columnWidth ?? width;
}

export default useContentWidth;
